var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightLevels(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#686868",
    d: "M30.2,8C27.3,5.9,23.6,5,20,5.6c-4.8,0.9-8.6,4.7-9.5,9.5c-0.6,3.8,0.9,7.7,3.9,10.2 c1.3,1.2,2.1,2.9,2.2,4.7h0.1v5.8c0,0.3,0.3,0.6,0.6,0.6H18c0.1,1.6,1.5,2.9,3.1,3h2.8c1.7-0.1,3-1.4,3.2-3h0.6 c0.3,0,0.6-0.3,0.6-0.6V30c0-1.9,0.9-3.7,2.4-4.8c2.5-2.1,3.9-5.2,3.9-8.4C34.5,13.4,32.9,10.1,30.2,8z M23.9,38.3H21 c-1-0.1-1.8-0.8-1.9-1.8h6.6C25.7,37.5,24.8,38.3,23.9,38.3z M27,35.3h-0.6h-7.9H18v-4.8h5.9h0.4H27V35.3z M21.5,20.3h1.9v9h-1.9 V20.3z M20.4,19.1h-1c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,1,0.9V19.1z M27,29.3h-2.4v-9h1c1.2,0,2.1-0.9,2.1-2.1 s-0.9-2.1-2.1-2.1c-1.2,0-2.1,0.9-2.2,2.1v0.9h-1.9v-0.9c0-1.2-1-2.2-2.2-2.2s-2.2,1-2.2,2.2c0.1,1.2,1,2.1,2.2,2.1h1v9h-2.5 c-0.3-1.9-1.2-3.6-2.6-4.9c-2.7-2.2-4-5.7-3.4-9.1c0.7-4.3,4.2-7.8,8.5-8.5c3.2-0.6,6.4,0.1,9,2.1c4.4,3.4,5.2,9.7,1.8,14 c-0.4,0.5-0.9,1-1.4,1.5C28.2,25.7,27.3,27.4,27,29.3z M24.7,19.1v-0.9c0-0.5,0.4-0.9,0.9-0.9c0,0,0.1,0,0.1,0 c0.5,0,0.9,0.4,0.9,0.9s-0.4,0.9-0.9,0.9H24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC00",
    d: "M19.4,17.3c-0.5,0-0.9,0.4-0.9,0.9s0.4,0.9,0.9,0.9h1v-0.9C20.3,17.7,19.9,17.3,19.4,17.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC00",
    d: "M26.5,18.3c0-0.5-0.4-0.9-0.9-0.9c0,0-0.1,0-0.1,0c-0.5,0-0.9,0.4-0.9,0.9v0.9h1 C26.1,19.1,26.5,18.7,26.5,18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M21,38.3h2.8c1,0,1.8-0.8,1.9-1.8h-6.6C19.3,37.5,20.1,38.3,21,38.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 20.3,
    fill: "#FFCC00",
    width: 1.9,
    height: 9
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "24.2,30.5 23.9,30.5 18,30.5 18,35.3 18.5,35.3 26.5,35.3 27,35.3 27,30.5  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC00",
    d: "M29.7,24.5c0.5-0.4,1-0.9,1.4-1.5c3.4-4.4,2.6-10.7-1.8-14c-2.6-2-5.8-2.7-9-2.1c-4.3,0.7-7.8,4.2-8.5,8.5 c-0.6,3.4,0.7,6.9,3.4,9.1c1.4,1.3,2.3,3,2.6,4.9h2.5v-9h-1c-1.2,0-2.1-0.9-2.2-2.1c0-1.2,1-2.2,2.2-2.2s2.2,1,2.2,2.2v0.9h1.9 v-0.9c0.1-1.2,1-2.1,2.2-2.1c1.2,0,2.1,0.9,2.1,2.1s-0.9,2.1-2.1,2.1h-1v9H27C27.3,27.4,28.2,25.7,29.7,24.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightLevels);
export default __webpack_public_path__ + "static/media/light_levels.5e50f86348a805ad1262784cb4de1a67.svg";
export { ForwardRef as ReactComponent };